<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Payment Gateways' }}</h2>
      <p>The payment providers the platform can transact through.</p>
    </div>
    <p-button label="Add Gateway" icon="pi pi-plus" (onClick)="openAdd()" />
  </div>

  <div class="card">
    <div class="toolbar">
      <p-iconfield iconPosition="left" class="search-field">
        <p-inputicon styleClass="pi pi-search" />
        <input type="text" pInputText placeholder="Search name, code or URL..." [ngModel]="search()"
          (ngModelChange)="search.set($event)">
      </p-iconfield>
      <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
    </div>

    <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th>Gateway</th>
          <th>Code</th>
          <th>Base URL</th>
          <th>Active</th>
          <th class="ta-r">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td class="name">
            <span class="gw">
              @if (r.logoUrl) { <img class="gw-logo" [src]="r.logoUrl" [alt]="r.gatewayName" /> }
              {{ r.gatewayName }}
            </span>
          </td>
          <td><span class="mono">{{ r.gatewayCode }}</span></td>
          <td class="mono url">{{ r.baseUrl || '—' }}</td>
          <td>
            <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
              <p-tag [value]="r.isActive ? 'Active' : 'Inactive'"
                [severity]="r.isActive ? 'success' : 'secondary'" />
            </span>
          </td>
          <td class="ta-r actions">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="state"><i class="pi pi-inbox"></i>
              <p>No payment gateways yet.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Gateway' : 'New Gateway'" styleClass="menu-dialog"
  [style]="{ width: '560px' }" [breakpoints]="{ '560px': '94vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="grid-2">
      <div class="field">
        <label>Gateway Code <span class="req">*</span></label>
        <input pInputText type="text" formControlName="gatewayCode" (input)="onCodeInput()"
          placeholder="RAZORPAY" autocomplete="off">
        @if (form.get('gatewayCode')?.touched && form.get('gatewayCode')?.invalid) {
          <small class="err">Gateway code is required</small>
        } @else {
          <small class="hint-muted">Unique, uppercase identifier.</small>
        }
      </div>
      <div class="field">
        <label>Gateway Name <span class="req">*</span></label>
        <input pInputText type="text" formControlName="gatewayName" placeholder="Razorpay">
        @if (form.get('gatewayName')?.touched && form.get('gatewayName')?.invalid) {
          <small class="err">Gateway name is required</small>
        }
      </div>
    </div>

    <div class="field">
      <label>Base URL</label>
      <input pInputText type="text" formControlName="baseUrl" placeholder="https://api.razorpay.com">
    </div>

    <div class="field">
      <label>Logo URL</label>
      <input pInputText type="text" formControlName="logoUrl" placeholder="https://.../logo.png">
    </div>

    <label class="switch-row">
      <p-toggleSwitch formControlName="isActive" />
      <span>Active</span>
    </label>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button label="Save" (onClick)="save()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>
